import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  ListJournaux,
  getAllJournalCaisses,
  getJournalCaisseByIdApi,
} from "../../_App/Redux/Slices/journalCaisse/journalCaisseSlice";
import {
  SelectedOrganisation,
  SelectedOrganisationId,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import { useTranslation } from "react-i18next";
import {
  allOrganisationsApi,
  ListOrganisations,
} from "../../_App/Redux/Slices/organisations/organisationSlice";
import SearchableDropdown from "../../_Layouts/RightBar/RightBar/cart/clientsTest";
import Select, { MultiValue } from "react-select";
import { OrganisationType } from "../../_App/Types/Entites/OrganisationType";
import { Interface } from "readline";
import { UserDataType } from "../../_App/Types/Forms/UserDataType";
import {
  findUsersApi,
  ListUsers,
} from "../../_App/Redux/Slices/users/userSlice";
import {
  exportExcel,
  exportExcelNoHeader,
  formatdate,
} from "../../_App/Helpers/helpers";
import { Spinner } from "react-bootstrap";
import AllStatistique from "../../Components/JournalCaisse/AllStatistique";
import TicketDeVentesJournal from "../../Components/Caisses/TicketDeCaisse/TicketDeVentesJournal";
import TicketClotureJournal from "../../Components/Caisses/TicketDeCaisse/TicketClotureJournal";
import { OrderType } from "../../_App/Types/Entites/Orders/OrderType";
import {
  findMouvementsCaisseByJournalApi,
  listMouvementsCaisseCommandeBySession,
} from "../../_App/Redux/Slices/mouvementCaisse/MouvementCaisseSlice";
import { JournalCaisseType } from "../../_App/Types/Entites/JournalCaisseType";
import { MouvementCaisseType } from "../../_App/Types/Entites/MouvementCaisseType";
import {
  findreglementsAPi,
  findReglementsByJournalApi,
} from "../../_App/Redux/Slices/payments/PaymentSlice";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";

const JournauxCaisse = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  interface FiltreInterface {
    listOrganisation: OrganisationType[];
    dateDebut: any;
    dateFin: any;
    listcaissiers: UserDataType[];
    etat: string;
    societe_id: string;
  }
  const today = new Date();
  const lastMonth = new Date(today);
  lastMonth.setMonth(today.getMonth() - 1);
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const listJournaux = useAppSelector(ListJournaux);
  const listOrganisation = useAppSelector(ListOrganisations);
  const societeid = useAppSelector(societeId);
  const listusers = useAppSelector(ListUsers);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [stateShow, setStateShow] = useState(false);
  const [show, setShow] = useState("");
  const [loader, setloader] = useState(false);

  const filtreStore = localStorage.getItem("filtreJournal");
  const fromJournalDetail = localStorage.getItem("JournalDetail");

  const [Filtre, setFiltre] = useState<FiltreInterface>({
    listOrganisation: [],
    dateDebut: formatdate(today),
    dateFin: formatdate(today),
    listcaissiers: [],
    etat: "Tout",
    societe_id: societeid,
  });

  const [showStatistiqueModal, setShowStatistiqueModal] =
    useState<boolean>(false);
  const [showTicket, setShowTicket] = useState<boolean>(false);
  const [showTicketCloture, setShowTicketCloture] = useState<boolean>(false);

  const [selectedJournalId, setSelectedJournalId] = useState<string | null>(
    null
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = listJournaux.slice(indexOfFirstItem, indexOfLastItem);

  const OrganisationOptions = listOrganisation?.map((option) => ({
    value: option._id,
    label: option.nom,
  }));
  const UsersOptions = listusers?.map((option) => ({
    value: option?._id,
    label: option?.nom + " " + option?.prenom,
  }));

  useEffect(() => {
    if (societeid) {
      dispatch(allOrganisationsApi(societeid));
      const copie = { ...Filtre };
      copie.societe_id = societeid;
      setFiltre(copie);
    }
  }, [societeid]);

  useEffect(() => {
    if (filtreStore && fromJournalDetail === "true") {
      const jsonfiltreStore: FiltreInterface = JSON.parse(filtreStore);
      setFiltre(jsonfiltreStore);
      GetJournaux(jsonfiltreStore);

      localStorage.setItem("JournalDetail", "false");
    } else {
      GetJournaux();
    }
  }, [filtreStore]);
  useEffect(() => {
    const data = { societe: societeid, organisation: Filtre.listOrganisation };
    dispatch(findUsersApi(data));
  }, [Filtre.listOrganisation]);

  useEffect(() => {
    setloader(false);
  }, [listJournaux]);
  const open = () => {
    if (show !== "show") {
      setShow("show");
      setStateShow(true);
    } else {
      setShow("");
      setStateShow(false);
    }
  };

  const handleSelectChangeOrganisation = (selectedOrganisations: any) => {
    const copie = { ...Filtre };
    copie.listOrganisation = selectedOrganisations.map(
      (item: any) => item.value
    );
    setFiltre(copie);
  };
  const handleSelectChangeUsers = (selectedUsers: any) => {
    const copie = { ...Filtre };
    copie.listcaissiers = selectedUsers.map((item: any) => item.value);
    setFiltre(copie);
  };

  const GetJournaux = (data: any = Filtre) => {
    setloader(true);
    dispatch(getAllJournalCaisses(data));
  };
  const handleStatistiqueButtonClick = (journalId: any) => {
    setSelectedJournalId(journalId);
    setShowStatistiqueModal(true);
  };

  const handleOpenVentesTickets = (journalId: any) => {
    setSelectedJournalId(journalId);
    setShowTicket(true);
  };
  const handleOpenClotureTickets = (journalId: any) => {
    setSelectedJournalId(journalId);
    setShowTicketCloture(true);
  };

  const getCodeJournalById = (journalId: string): string | null => {
    const foundJournal = listJournaux.find(
      (journal) => journal._id === journalId
    );
    return foundJournal ? foundJournal.code_journal || null : null;
  };
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        GetJournaux();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const sessionXorderMouvements = useAppSelector(
    listMouvementsCaisseCommandeBySession
  );
  const [selectedJournal, setSelectedJournal] = useState<string | null>(null);
  const [reglements, setReglements] = useState<any>({});

  // New effect: Wait for sessionXorderMouvements to be ready

  interface DataRow {
    date: string;
    client: string;
    numFacture: string;
    article: string;
    designation: string;
    qte: number;
    total_ttc: number;
    remise: any;
    prixNetHT: number;
    prixNetTTC: any;
    societe: string;
  }

  const exportToExcel = async (id: string) => {
    try {
      console.log("Starting exportToExcel function with id:", id);

      const res = await dispatch(findMouvementsCaisseByJournalApi(id));
      console.log("API Response (findMouvementsCaisseByJournalApi):", res);

      const journal = await dispatch(getJournalCaisseByIdApi(id));
      console.log("API Response (getJournalCaisseByIdApi):", journal);

      if (!res?.payload) {
        console.error(
          "Error: No payload in findMouvementsCaisseByJournalApi response"
        );
        return;
      }

      if (!journal?.payload) {
        console.error("Error: No payload in getJournalCaisseByIdApi response");
        return;
      }

      // Log the raw payload structure
      console.log("Raw res.payload:", res.payload);
      console.log("Type of res.payload:", typeof res.payload);

      // Handle different response formats
      const orders: MouvementCaisseType[] = Array.isArray(res.payload)
        ? res.payload
        : Object.values(res.payload);

      console.log("Processed orders array:", orders);
      console.log("Number of orders:", orders.length);

      if (!orders.length) {
        console.error("Error: No orders found after processing payload");
        return;
      }

      // Log the first order to see its structure
      if (orders[0]) {
        console.log("First order structure:", orders[0]);
        console.log("Items in first order:", orders[0].order_id.items);
        console.log(
          "Number of items in first order:",
          orders[0].order_id?.items.length || 0
        );
      }

      const list: DataRow[] = orders.flatMap((order: MouvementCaisseType) => {
        const items = order.order_id.items || [];
        console.log(
          `Processing order ${order.order_id.order_number} with ${items.length} items`
        );

        return items.map((item) => {
          const row = {
            date: order.date?.toString().split("T")[0] || "",
            client: order.order_id.client_id?.nom || "",
            numFacture: order.order_id.order_number || "",
            article: item.article?.code_article || "",
            designation: item.article?.titre?.fr || "",
            qte: item.quantity || 0,
            total_ttc: item.prix_total || 0,
            remise: item.remise ? item.remise + "%" : "0%",
            prixNetHT: Number(
              (
                (item.article?.prix_vente_ht || 0) -
                (((item.article?.prix_vente_ht || 0) * (item.remise || 0)) /
                  100) *
                  item.quantity
              ).toFixed(3)
            ),
            prixNetTTC: item.prixNet?.toFixed(3) || "0",
            societe: order.order_id?.societe_id.nom || "",
          };
          console.log("Created row:", row);
          return row;
        });
      });

      console.log("Final list to export:", list);
      console.log("Number of rows in list:", list.length);

      if (list.length) {
        console.log("Exporting data to Excel...");
        exportExcel(
          `articles_journal_${journal.payload.code_journal}.xlsx`,
          "articles_journal",
          list
        );
      } else {
        console.error("Error: No data in final list to export");
        console.log("Here is the complete data flow for debugging:");
        console.log("res:", res);
        console.log("journal:", journal);
        console.log("orders:", orders);
      }
    } catch (error) {
      console.error("Error in exportToExcel:", error);
    }
  };
  useEffect(() => {
    console.log(selectedJournal);
  }, [selectedJournal]);
  /********REGELEMENT  */

  const exportReglementsToExcel = async (typeP: any) => {
    const res = await dispatch(
      findReglementsByJournalApi({ ...Filtre, payment_method: typeP })
    );
    if (res.payload.data?.details) {
      let list: any[] = [];
      // Iterate through each payment
      res.payload.data.details?.forEach((payment: any) => {
        // First line for each payment
        const day = String(new Date(payment.date).getDate()).padStart(2, "0");
        const month = String(new Date(payment.date).getMonth() + 1).padStart(
          2,
          "0"
        );
        const year = new Date(payment.date).getFullYear();
        const todayFormatted = `${day}${month}${year}`; // "10062025" for June 10, 2025
        const line1 = {
          P: "P",
          ICHA: "ICHA",
          payment_method:
            payment.payment_method === "Espéces"
              ? "ESPECES"
              : payment.payment_method === "Carte bancaire"
              ? "CTPE"
              : payment.payment_method,
          IN105: "IN105",
          ICHA2: "ICHA",

          blank1: "",
          date: todayFormatted, // Format date as needed
          blank2: "",
          blank3: "",
          amount: payment.montant,
          blank4: "",
          ABINE: typeP === "Carte bancaire" ? undefined : "ABINE",
        };

        // Second line for each payment
        const line2 = {
          D: "D",
          TUN: "TUN",
          ENC: "ENC",
          Amount: payment.montant,
          TND: "TND",
          blank5: "",
          blank6: "",
          blank7: "",
          blank8: "",
          blank9: "",
          blank10: "",
          blank11: "",
        };

        // Add both lines to the list
        list.push(line1);
        list.push(line2);
      });

      exportExcelNoHeader(
        `reglements_${typeP}.xlsx`,
        `reglements_${typeP}`,
        list
      );
    } else {
      ToastWarning("Un problème de changement des règlements ");
    }
  };
  const calculTotalEcart = (list:any [])=>{
    const totalEcart = list.reduce(
      (accumulator: any, currentValue: any) =>
        accumulator + (currentValue?.ecart||0),
      0
    );
    return totalEcart
  }
  return (
    <div className="row layout-spacing">
      <div className="col-lg-12">
        <div className="statbox widget box box-shadow">
          <div className="navbar-item flex-row search-ul navbar-dropdown">
            <div className="nav-item dropdown language-dropdown more-dropdown">
              {" "}
              <label>Date Debut</label>
              <input
                type="date"
                className="form-control row"
                onChange={(e) => {
                  setFiltre((prev) => ({
                    ...prev,
                    dateDebut: e.target.value,
                  }));
                }}
                value={Filtre.dateDebut}
              />
            </div>
            <div className="nav-item dropdown language-dropdown more-dropdown">
              <label>Date Fin</label>

              <input
                type="date"
                className="form-control row"
                onChange={(e) => {
                  setFiltre((prev) => ({
                    ...prev,
                    dateFin: e.target.value,
                  }));
                }}
                value={Filtre.dateFin}
              />
            </div>
            {/*******************************Organisation  ***********************/}
            <div className="nav-item dropdown language-dropdown more-dropdown">
              <label>Organisations</label>
              <Select
                isMulti
                options={OrganisationOptions}
                isSearchable={true}
                onChange={(newSelectedOptions) =>
                  handleSelectChangeOrganisation(newSelectedOptions)
                }
              />
            </div>
            {/*******************************Caissier  ***********************/}

            <div className="nav-item dropdown language-dropdown more-dropdown">
              <label>Caissier</label>
              <Select
                isMulti
                options={UsersOptions}
                isSearchable={true}
                onChange={(newSelectedOptions) =>
                  handleSelectChangeUsers(newSelectedOptions)
                }
              />
            </div>

            <div
              className="nav-item dropdown language-dropdown more-dropdown"
              onClick={open}
              style={{
                display: "flex",
                justifyContent: "right",
                float: "right",
              }}
            >
              <div
                className={"dropdown custom-dropdown-icon " + show}
                style={{ cursor: "pointer" }}
              >
                <a
                  className="dropdown-toggle btn"
                  href="#"
                  role="button"
                  id="customDropdown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={stateShow}
                >
                  <span> {Filtre.etat}</span>{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-chevron-down"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </a>
                <div
                  className={"dropdown-menu dropdown-menu-right " + show}
                  aria-labelledby="customDropdown"
                >
                  <div
                    className="dropdown-item"
                    data-img-value="flag-de3"
                    data-value="Tout"
                    onClick={() => {
                      setFiltre((prev) => ({
                        ...prev,
                        etat: "Tout",
                      }));
                    }}
                  >
                    {t("Tout")}
                  </div>

                  <div
                    className="dropdown-item"
                    data-img-value="flag-ca2"
                    data-value="Cloturé"
                    onClick={() => {
                      setFiltre((prev) => ({
                        ...prev,
                        etat: "Cloturé",
                      }));
                    }}
                  >
                    {t("Cloturé")}
                  </div>
                  <div
                    className="dropdown-item"
                    data-img-value="flag-ca2"
                    data-value="Non cloturé"
                    onClick={() => {
                      setFiltre((prev) => ({
                        ...prev,
                        etat: "Non cloturé",
                      }));
                    }}
                  >
                    {t("Non cloturé")}
                  </div>
                  <div
                    className="dropdown-item"
                    data-img-value="flag-ca2"
                    data-value="Validé"
                    onClick={() => {
                      setFiltre((prev) => ({
                        ...prev,
                        etat: "Validé",
                      }));
                    }}
                  >
                    {t("Validé")}
                  </div>
                </div>
              </div>
            </div>

            <div
              className="nav-item dropdown language-dropdown more-dropdown"
              onClick={() => GetJournaux(Filtre)}
            >
              <button className="btn btn-search">
                {" "}
                <i className="fas fa-search"></i>
              </button>
            </div>
          </div>

          <div
            className="widget-content widget-content-area"
            style={{ overflowX: "auto" }}
          >
            {loader ? (
              <div>
                <Spinner />
              </div>
            ) : (
              <>
                <button
                  className="btn btn-export m-0"
                  onClick={() => exportReglementsToExcel("Carte bancaire")}
                >
                  {t("Réglements TPE")}
                </button>
                <button
                  className="btn btn-export m-0"
                  onClick={() => exportReglementsToExcel("Espéces")}
                >
                  {t("Réglements Espéces")}
                </button>
                <table id="style-2" className="table style-2 table-hover">
                  <thead>
                    <tr>
                      <th
                        className="checkbox-column dt-no-sorting"
                        style={{ fontSize: "15px" }}
                      >
                        Code Journal
                      </th>
                      <th style={{ fontSize: "15px" }}>Date</th>
                      <th style={{ fontSize: "15px" }}>Utilisateur</th>
                      <th style={{ fontSize: "15px" }}>Fond initial</th>
                      <th style={{ fontSize: "15px" }}>Fond final</th>
                      <th style={{ fontSize: "15px" }}>Cloturé</th>
                      <th style={{ fontSize: "15px" }}>Validé</th>{" "}
                      <th style={{ fontSize: "15px" }}>Ecart {calculTotalEcart(listJournaux)}</th>
                      <th
                        style={{ fontSize: "15px", textAlign: "center" }}
                        colSpan={2}
                      >
                        Actions
                      </th>
                      <th>Ticktes</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems &&
                      currentItems.map((item, index) => (
                        <tr key={item._id}>
                          <td
                            className="checkbox-column lien-bleu-souligne "
                            style={{ fontSize: "15px" }}
                            onClick={(e) => {
                              localStorage.setItem(
                                "filtreJournal",
                                JSON.stringify(Filtre)
                              );
                              localStorage.setItem("JournalDetail", "true");

                              window.location.href =
                                "/mouvementcaisse/" + item._id;
                            }}
                          >
                            {item.code_journal}
                          </td>
                          <td style={{ fontSize: "15px" }}>
                            {item?.date?.toString().split("T")[0]}
                          </td>
                          <td style={{ fontSize: "15px" }}>
                            {item.user_id?.nom}
                          </td>
                          <td style={{ fontSize: "15px" }}>
                            {item.font_initial}
                          </td>
                          <td style={{ fontSize: "15px" }}>
                            {item.font_final}
                          </td>
                          <td style={{ fontSize: "15px" }}>
                            {item.cloture ? "oui" : "non"}
                          </td>
                          <td style={{ fontSize: "15px" }}>
                            <div
                              className={
                                item.valide
                                  ? "badge btn-success"
                                  : "badge btn-danger"
                              }
                              style={{ width: "100%", fontSize: "14px" }}
                            >
                              {" "}
                              {item.valide ? "Validé" : "Non validé"}
                            </div>
                          </td>
                          <td style={{ fontSize: "15px" }}>
                            {item.Validator?.nom}
                          </td>
                          <td style={{ fontSize: "15px" }}>{item.ecart}</td>
                          <td>
                            {" "}
                            <button
                              onClick={() => {
                                exportToExcel(item._id);
                              }}
                              className="btn btn-export m-0"
                              id={item._id}
                            >
                              <i className="fas fa-file-excel mr-2"></i>
                              {t("Export Excel")}
                            </button>
                          </td>
                          <td>
                            <a
                              className=""
                              onClick={() => handleOpenVentesTickets(item._id)}
                            >
                              {t("Ventes")}
                            </a>{" "}
                            <br></br>
                            <a
                              className=""
                              onClick={() => handleOpenClotureTickets(item._id)}
                            >
                              {t("Cloture")}
                            </a>
                          </td>
                          <td>
                            <button
                              className="btn btn-primary-app"
                              onClick={() =>
                                handleStatistiqueButtonClick(item._id)
                              }
                            >
                              {t("Statistique")}
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>


                   <tfoot>
                      <th
                        
                      >
                      </th>
                      <th style={{ fontSize: "15px" }}></th>
                      <th style={{ fontSize: "15px" }}></th>
                      <th style={{ fontSize: "15px" }}> </th>
                      <th style={{ fontSize: "15px" }}> </th>
                      <th style={{ fontSize: "15px" }}></th>
                      <th style={{ fontSize: "15px" }}></th>{" "}
                      <th style={{ fontSize: "15px" }}>Total ecart {calculTotalEcart(currentItems)}</th>
                      <th
                        colSpan={2}
                      >
                      </th>
                      <th></th>
                      <th></th>
                  </tfoot>
                </table>
              </>
            )}
          </div>
          <ul className="pagination" style={{ justifyContent: "center" }}>
            {Array.from(
              {
                length: Math.ceil(listJournaux.length / itemsPerPage),
              },
              (_, index) => (
                <li
                  key={index}
                  className={`page-item ${
                    currentPage === index + 1 ? "active" : ""
                  }`}
                  style={{ backgroundColor: "transparent" }}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(index + 1)}
                  >
                    {index + 1}
                  </button>
                </li>
              )
            )}
          </ul>
        </div>
        <AllStatistique
          onClose={() => {
            setShowStatistiqueModal(false);
            setSelectedJournalId(null);
          }}
          journalId={selectedJournalId ?? ""}
          showModal={showStatistiqueModal}
          getCodeJournalById={getCodeJournalById}
        />
        <TicketDeVentesJournal
          id={selectedJournalId ?? ""}
          ShowModal={showTicket}
          setShowModal={setShowTicket}
        />
        <TicketClotureJournal
          id={selectedJournalId ?? ""}
          ShowModal={showTicketCloture}
          setShowModal={setShowTicketCloture}
        />
      </div>
    </div>
  );
};

export default JournauxCaisse;
